import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <h3 className="text-white font-bold text-lg mb-3">CSSBuy Spreadsheet</h3>
            <p className="text-sm text-gray-400 leading-relaxed">
              {t('siteDescription')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-3 uppercase tracking-wide">{t('navGuide')}</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => document.getElementById('what-is')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm text-gray-400 hover:text-white transition-colors">
                  {t('whatIsTitle')}
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('why-use')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm text-gray-400 hover:text-white transition-colors">
                  {t('whyUseTitle')}
                </button>
              </li>
              <li>
                <Link to="/article" className="text-sm text-gray-400 hover:text-white transition-colors">
                  {t('articleH1')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-3 uppercase tracking-wide">{t('commercialTitle')}</h4>
            <ul className="space-y-2">
              <li><button onClick={() => document.getElementById('commercial')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm text-gray-400 hover:text-white transition-colors">{t('reviewTitle')}</button></li>
              <li><button onClick={() => document.getElementById('commercial')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm text-gray-400 hover:text-white transition-colors">{t('shippingCostTitle')}</button></li>
              <li><button onClick={() => document.getElementById('commercial')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm text-gray-400 hover:text-white transition-colors">{t('couponTitle')}</button></li>
              <li><button onClick={() => document.getElementById('commercial')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm text-gray-400 hover:text-white transition-colors">{t('warehouseTitle')}</button></li>
              <li><button onClick={() => document.getElementById('commercial')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm text-gray-400 hover:text-white transition-colors">{t('legitTitle')}</button></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-3 uppercase tracking-wide">Legal</h4>
            <ul className="space-y-2">
              <li><span className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">{t('footerPrivacy')}</span></li>
              <li><span className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">{t('footerTerms')}</span></li>
              <li><span className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">{t('footerDisclaimerLink')}</span></li>
              <li><span className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">{t('footerContact')}</span></li>
            </ul>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-10 pt-6 border-t border-gray-800">
          <p className="text-xs text-gray-500 text-center leading-relaxed">
            {t('footerDisclaimer')}
          </p>
        </div>
      </div>
    </footer>
  );
}